import { Form, Input, Select, Tooltip } from 'antd';
import { IMobileRef, IPOAccount, IPOMessage, IPOModal, IPOUtils, MobileInput } from '../../..';

import React, { FC, ReactNode, useEffect, useRef, useState } from 'react';
import { EnableWrap } from './style';
interface IStaffEnableProps {
	user: IPOAccount.IStaff;
	isShowEnable: boolean;
	handleChange: () => void;
	showRight?: boolean;
	handleUpdateBasic: (staff: IPOAccount.IEditAccount) => Promise<void>;
	handleUpdateRole?: (role: IPOAccount.StaffRoleEnum) => Promise<void>;
	handleEnableChange: (status: string) => Promise<void>;
	uploadEle: ReactNode;
}

export const EnableStaff: FC<IStaffEnableProps> = ({
	user,
	isShowEnable,
	handleChange,
	showRight,
	handleEnableChange,
	handleUpdateRole,
	handleUpdateBasic,
	uploadEle,
}) => {
	showRight = showRight ?? false;
	const { Option } = Select;
	const mobileRef = useRef<IMobileRef>();
	const [enableForm] = Form.useForm();

	const [copyAvatar, setCopyAvatar] = useState<string | undefined>('');

	useEffect(() => {
		if (!isShowEnable) {
			enableForm.resetFields();
		} else {
			enableForm.setFieldsValue({ ...user });
			setCopyAvatar(user.avatar);
		}
	}, [isShowEnable]);

	const handleEnableStaff: () => void = () => {
		const email = enableForm.getFieldValue('email')?.trim() ?? '';
		const name = enableForm.getFieldValue('name')?.trim() ?? '';
		const name2 = enableForm.getFieldValue('name2')?.trim() ?? '';
		const avatar = user.avatar ?? '';

		// 更新基本信息
		IPOUtils.regAccount({ name, name2, email, avatar }, false).then(() => {
			handleEnableChange('1').then(() => {
				const isSameBasic =
					user.name === name &&
					user.name2 === name2 &&
					user.email === email &&
					avatar === copyAvatar;
				const isSameRole = handleUpdateRole && user.role === enableForm.getFieldValue('role');
				const newPro = [];
				!isSameBasic && newPro.push(handleUpdateBasic({ name, name2, email, avatar }));
				!isSameRole &&
					newPro.push(handleUpdateRole && handleUpdateRole(enableForm.getFieldValue('role')));
				Promise.all(newPro).then(() => {
					return IPOMessage.success('启用成功');
				});
				handleChange();
			});
		});
	};

	return (
		<IPOModal
			title="启用员工"
			isShowPadding
			visible={isShowEnable}
			cancelText={'取消'}
			okText={
				<Tooltip
					title="可重新启用该员工，启用后该员工可登录此后台管理系统。"
					mouseEnterDelay={2}
					mouseLeaveDelay={0.5}>
					启用
				</Tooltip>
			}
			onOk={() => handleEnableStaff()}
			onCancel={() => handleChange()}
			getContainer={false}
			maskClosable={false}>
			<EnableWrap>
				<Form form={enableForm} colon={false} labelCol={{ span: 3, offset: 0 }}>
					<Form.Item label="头像" name="avatar">
						{uploadEle}
					</Form.Item>
					<Form.Item label="英文名" name="name">
						<Input />
					</Form.Item>
					<Form.Item label="中文名" name="name2">
						<Input />
					</Form.Item>
					<Form.Item
						label="手机号"
						name="mobile"
						rules={[{ required: true, message: '请输入手机号' }]}>
						<MobileInput
							mobileRef={mobileRef}
							mobileInfo={{ areaCode: user.areaCode, phoneNum: user.mobile }}
							disabled
							allowClear={false}
						/>
					</Form.Item>
					<Form.Item label="邮箱" name="email">
						<Input />
					</Form.Item>
					{showRight && (
						<Form.Item
							label="权限"
							name="role"
							rules={[{ required: true, message: 'Please input your username!' }]}>
							<Select value={enableForm.getFieldValue('role')} style={{ width: '100%' }}>
								<Option value={IPOAccount.StaffRoleEnum.CUSTOM}>普通权限</Option>
								<Option value={IPOAccount.StaffRoleEnum.HIGH_LEVEL}>高级权限</Option>
								<Option value={IPOAccount.StaffRoleEnum.READ_ONLY}>监管方权限</Option>
							</Select>
						</Form.Item>
					)}
				</Form>
				<div className="tips-wrap">
					<div>提示：以下为之前历史信息，仅供参考</div>
					<div className="tips-item">
						<span>中文名：</span>
						<span>{user.name}</span>
					</div>
					<div className="tips-item">
						<span>英文名：</span>
						<span>{user.name2}</span>
					</div>
					<div className="tips-item">
						<span>手机号：</span>
						<span>
							{user.areaCode}
							{user.mobile}
						</span>
					</div>
					<div className="tips-item">
						<span>邮箱：</span>
						<span>{user.email}</span>
					</div>
				</div>
			</EnableWrap>
		</IPOModal>
	);
};
